import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
export const FormError = t0 => {
  const $ = _c(6);
  const {
    message,
    testId
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      alignItems: "center",
      justifyContent: "center"
    };
    t2 = <i className="material-symbols-close-rounded w-[20px] h-[20px] text-(--mui-palette-error-main)" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "error.main"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== message || $[4] !== testId) {
    t4 = <Stack direction="row" sx={t1}>{t2}<Typography variant="subtitle1" data-testid={testId} sx={t3}>{message}</Typography></Stack>;
    $[3] = message;
    $[4] = testId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};